import { useContext } from "react";
import TextContext from "./TextContext";

const useText = () => useContext(TextContext);

export default useText;
